import module from 'cliente/module.js'

const schema = {
  idMoneda: 'number',
  activo: 'boolean',
}

export class ClienteInformacionBancosDocumentoService {
  constructor ($http) {
    this.$http = $http
  }

  get (idCliente, idCuenta, idDocumento) {
    return this.$http.get('/api/clientes/cliente/informacion/bancos/documento', {
      params: {
        idCliente: idCliente,
        idCuenta: idCuenta,
        idDocumento: idDocumento,
      },
    })
  }

  post (idCliente, idCuenta, archivo) {
    let formData = new global.FormData()
    formData.append('documento', archivo)

    return this.$http.post('/api/clientes/cliente/informacion/bancos/documento', formData, {
      params: {
        idCliente: idCliente,
        idCuenta: idCuenta,
      },
      schema,
    })
  }
}

module.service('ClienteInformacionBancosDocumento', ClienteInformacionBancosDocumentoService)



// WEBPACK FOOTER //
// ./src/cliente/services/Informacion/Bancos/Documento.js